<template>
  <div>
    <md-dialog :md-active.sync="isVisible">
      <h5 :class="alert" v-if="validationError" v-text="resultMessage"></h5>
      <div class="dialogWrapper">
        <md-dialog-title>Please answers following questions to proceed further.</md-dialog-title>
        <div class="md-layout">
          <div class="md-layout-item md-small-size-100 md-size-100">
            1. Please specify the purpose of the application. For example, purchase the asset, Refinance loan on the
            asset. If there is any misalignment between the application data and the response to this question then the
            application will not be able to be submitted to credit. (Application will then need to be amended in Pepper
            system before submitting)
          </div>
          <div class="md-layout-item">
            <md-radio v-model="whatIsThePurposeOfThisApplication" value="Purchase the asset">
              Purchase the asset
            </md-radio>
            <md-radio v-model="whatIsThePurposeOfThisApplication" value="Purchase the asset plus finance insurances">
              Purchase the asset plus finance insurances
            </md-radio>
            <md-radio v-model="whatIsThePurposeOfThisApplication" value="Refinance loan on the asset">
              Refinance loan on the asset
            </md-radio>
            <md-radio v-model="whatIsThePurposeOfThisApplication"
              value="Refinance loan on the asset plus finance insurances">
              Refinance loan on the asset plus finance insurances
            </md-radio>
          </div>
          <div class="md-layout-item md-size-100">
            <label>2. Specify why does this loan term suits your requirement. If you choose other, please provide more
              details in details field.</label>
            <validated-autocomplete-input class="md-layout-item md-size-60" force
              v-model="whyDoesThisLoanTermSuitYourRequirements" :options="requirementsDetails">
            </validated-autocomplete-input>
          </div>
          <div class="md-layout-item md-size-60" v-if="whyDoesThisLoanTermSuitYourRequirements === 'Other'">
            <label>Please enter detail of this loan term suits your requirements</label>
            <md-field>
              <md-input v-model="whyDoesThisLoanTermSuitYourRequirementsDetails"></md-input>
            </md-field>
          </div>
          <div class="md-layout-item  md-small-size-100 md-size-100">
            3. Please specify what are you looking for in your loan. You can pass more than one of the allowed values.
            Allowed values are Competitive Interest Rate, Service, Broker Recommendation, I can make additional
            repayments at no cost, I can repay the loan early (fees & charges apply), A balloon repayment
          </div>
          <div class="md-layout-item md-small-size-100 md-size-100">
            <md-checkbox v-model="whatAreYouLookingForInYourLoan" value="Competitive Interest Rate">
              Competitive Interest Rate
            </md-checkbox>
            <md-checkbox v-model="whatAreYouLookingForInYourLoan" value="Service">
              Service
            </md-checkbox>
            <md-checkbox v-model="whatAreYouLookingForInYourLoan" value="Broker Recommendation">
              Broker Recommendation
            </md-checkbox>
            <md-checkbox v-model="whatAreYouLookingForInYourLoan" value="A balloon repayment">
              A balloon repayment
            </md-checkbox>
            <md-checkbox v-model="whatAreYouLookingForInYourLoan" value="I can make additional repayments at no cost">
              I can make additional repayments at no cost
            </md-checkbox>
            <md-checkbox v-model="whatAreYouLookingForInYourLoan"
              value="I can repay the loan early (fees & charges apply)">
              I can repay the loan early (fees & charges apply)
            </md-checkbox>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-100">
            4. Do you plan or anticipate any foreseeable changes to your personal circumstances that may adversely impact
            your ability to repay the loan. If yes, answer following questions.
          </div>
          <div class="md-layout-item  md-small-size-100 md-size-100">
            <md-radio v-model="anyForeseeableChangesImpactingLoanRepayment" :value="true">
              Yes
            </md-radio>
            <md-radio v-model="anyForeseeableChangesImpactingLoanRepayment" :value="false">
              No
            </md-radio>
          </div>
          <div class="md-layout-item  md-small-size-100 md-size-100">
            <label> 5. What type of change is expected which may adversely impact your ability to repay the loan.</label>
            <validated-autocomplete-input class="md-layout-item  md-small-size-100 md-size-60" force
              v-model="typeOfChangeExpected" :options="typeOfChange">
            </validated-autocomplete-input>
          </div>
          <div class="md-layout-item  md-small-size-100 md-size-100">
            <label>
              6. How does the applicant(s) intend to meet their loan repayments following the planned or anticipated
              change?
            </label>
            <md-field>
              <md-input v-model="howApplicantIntendToDoLoanRepaymentAfterChange"></md-input>
            </md-field>
          </div>
          <div class="md-layout-item  md-small-size-100 md-size-100">
            7. Are you aware that financing the cost of insurances or add-ons will increase the loan amount and interest
            paid over the loan term. This is relevant for the applications where one or more insurance premiums are
            being financed. If No is selected with insurance financed on the application, it will not be able to submit
            to credit.
          </div>
          <div class="md-layout-item  md-small-size-100 md-size-100">
            <md-radio v-model="increaseInLoanAmountForFinancingCostOfInsurance" :value="true">
              Yes
            </md-radio>
            <md-radio v-model="increaseInLoanAmountForFinancingCostOfInsurance" :value="false">
              No
            </md-radio>
          </div>
          <div class="md-layout-item  md-small-size-100 md-size-100">
            8. Do you understand and acknowledge that you will be required to make a large payment (balloon payment)
            at the end of the loan and will pay interest on the balloon over the term of the loan? This is relevant
            where a balloon repayment has been included on the application. If No is selected with a balloon amount
            included on the application, it will not be able to submit to credit. If yes is selected, answer following
            question.
          </div>
          <div class="md-layout-item md-small-size-100 md-size-100">
            <md-radio v-model="balloonPaymentAtTheEndOfTheLoan" :value="true">
              Yes
            </md-radio>
            <md-radio v-model="balloonPaymentAtTheEndOfTheLoan" :value="false">
              No
            </md-radio>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-100">
            9. What do you intend to do at the end of the loan term with the balloon payment
          </div>
          <div class="md-layout-item md-small-size-100 md-size-100">
            <md-radio v-model="whatToDoWithBalloonPaymentAtTheEndOfTheLoanTerm" value="Payout">
              Payout
            </md-radio>
            <md-radio v-model="whatToDoWithBalloonPaymentAtTheEndOfTheLoanTerm" value="Refinance the loan">
              Refinance the loan
            </md-radio>
            <md-radio v-model="whatToDoWithBalloonPaymentAtTheEndOfTheLoanTerm" value="Sell the asset">
              Sell the asset
            </md-radio>
            <md-radio v-model="whatToDoWithBalloonPaymentAtTheEndOfTheLoanTerm" value="Trade in for a new vehicle">
              Trade in for a new vehicle
            </md-radio>
          </div>
          <div class="md-layout-item  md-small-size-100 md-size-100">
            <label>
              10. Provide the customer's reason for refinancing. This is relevant where the asset supplier type is
              refinance.
            </label>
            <validated-autocomplete-input class="md-layout-item  md-small-size-100 md-size-60"
              v-model="whyAreYouLookingAtRefinancing" :options="lookingAtRefinancing">
            </validated-autocomplete-input>
          </div>
          <div class="md-layout-item md-size-60">
            <label>
              11. Please provide more details to support above answer
            </label>
            <md-field>
              <md-input v-model="detailedReasonForRefinancing"></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-100">
            12. Is the applicant planning to retire before the completion of the loan? This is relevant if the
            applicant is 65 years old or more. If yes, answer following question.
          </div>
          <div class="md-layout-item md-small-size-100 md-size-100">
            <md-radio v-model="isApplicantPlanningToRetireBeforeLoanCompletion" :value="true">
              Yes
            </md-radio>
            <md-radio v-model="isApplicantPlanningToRetireBeforeLoanCompletion" :value="false">
              No
            </md-radio>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-100">
            13. How would the applicant propose to repay the loan if he/she is 65 years old or more? If response is
            other, provide more details in details field.
          </div>
          <div class="md-layout-item md-small-size-100 md-size-100">
            <md-radio v-model="howTheApplicantProposeToRepayTheLoanResponse" value="Pension">
              Pension
            </md-radio>
            <md-radio v-model="howTheApplicantProposeToRepayTheLoanResponse" value="Superannuation">
              Superannuation
            </md-radio>
            <md-radio v-model="howTheApplicantProposeToRepayTheLoanResponse" value="Income from other investments">
              Income from other investments
            </md-radio>
            <md-radio v-model="howTheApplicantProposeToRepayTheLoanResponse" value="Co-applicant’s income">
              Co-applicant’s income
            </md-radio>
            <md-radio v-model="howTheApplicantProposeToRepayTheLoanResponse" value="Other">
              Other
            </md-radio>
          </div>
          <div class="md-layout-item md-size-60">
            <label>
              14. More details about how the applicant propose to repay the loan.
            </label>
            <md-field>
              <md-input v-model="howTheApplicantProposeToRepayTheLoanDetails"></md-input>
            </md-field>
          </div>
        </div>
      </div>
      <md-dialog-actions>
        <md-button class="md-primary" :disabled="isProceed()" @click="proceed()">Proceed</md-button>
        <md-button class="md-primary" @click="closeNccpPopup">Close</md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>
      
<script>
import ValidatedInputs from "@/components/ValidatedInput";
export default {
  components: {
    ...ValidatedInputs,
  },
  props: {
    visible: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      applicantNCCP: {},
      alert: 'proceed_error',
      resultMessage: '',
      validationError: true,
      whatIsThePurposeOfThisApplication: null,
      requirementsDetails: ['Want the maximum amount of time with the minimum repayment', 'Want to be able to pay off the loan over the selected term as it suits my budget', 'I want to pay off the loan as quickly as possible (and acknowledge that fees and charges apply for early payout of the loan)', 'I will be looking to sell the car/ trade in at the end of the loan term', 'Other'],
      typeOfChange: ['End of employment contract/ loss of employment', 'Leaving employment', 'Increased debt repayment for a new/ existing loan', 'Large expenditure', 'Medical treatment/ illness', 'Extended unpaid leave (e.g. study or parental leave)', 'Change to family situation', 'Retirement', 'Buying a house', 'Other (please give details along with management strategy)'],
      lookingAtRefinancing: ['Reduced Repayments', 'Lower Interest Rate', 'Dissatisfied with other lender', 'End of current loan term and wanting to extend loan term', 'Other'],
      anyForeseeableChangesImpactingLoanRepayment: null,
      increaseInLoanAmountForFinancingCostOfInsurance: null,
      balloonPaymentAtTheEndOfTheLoan: null,
      typeOfChangeExpected: null,
      isApplicantPlanningToRetireBeforeLoanCompletion: null,
      whyDoesThisLoanTermSuitYourRequirementsDetails: null,
      whatToDoWithBalloonPaymentAtTheEndOfTheLoanTerm: null,
      howTheApplicantProposeToRepayTheLoanResponse: null,
      howApplicantIntendToDoLoanRepaymentAfterChange: null,
      detailedReasonForRefinancing: null,
      howTheApplicantProposeToRepayTheLoanDetails: null,
      whyDoesThisLoanTermSuitYourRequirements: null,
      whatAreYouLookingForInYourLoan: [],
      whyAreYouLookingAtRefinancing: null,
    };
  },

  computed: {
    isVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit("closeNccpPopup", value);
      },
    }
  },
  methods: {
    isProceed() {
      if (
        !this.whatIsThePurposeOfThisApplication ||
        (!this.whyDoesThisLoanTermSuitYourRequirements ||
          (this.whyDoesThisLoanTermSuitYourRequirements === "Other"
            && !this.whyDoesThisLoanTermSuitYourRequirementsDetails)) ||
        this.whatAreYouLookingForInYourLoan.length == 0 ||
        !this.howTheApplicantProposeToRepayTheLoanDetails ||
        this.anyForeseeableChangesImpactingLoanRepayment === null ||
        !this.typeOfChangeExpected ||
        !this.howApplicantIntendToDoLoanRepaymentAfterChange ||
        this.increaseInLoanAmountForFinancingCostOfInsurance === null ||
        !this.balloonPaymentAtTheEndOfTheLoan ||
        !this.whatToDoWithBalloonPaymentAtTheEndOfTheLoanTerm ||
        !this.whyAreYouLookingAtRefinancing ||
        !this.detailedReasonForRefinancing ||
        this.isApplicantPlanningToRetireBeforeLoanCompletion === null ||
        !this.howTheApplicantProposeToRepayTheLoanResponse
      ) {
        this.alert = 'proceed_error';
        this.resultMessage = 'Please enter valid details to proceed further';
        this.validationError = true;
        return true;
      } else {
        this.validationError = false;
        return false;
      }
    },
    proceed() {
      const applicantNCCP = {
        whatIsThePurposeOfThisApplication: this.whatIsThePurposeOfThisApplication,
        whyDoesThisLoanTermSuitYourRequirements: this.whyDoesThisLoanTermSuitYourRequirements,
        whatAreYouLookingForInYourLoan: this.whatAreYouLookingForInYourLoan,
        howTheApplicantProposeToRepayTheLoanDetails: this.howTheApplicantProposeToRepayTheLoanDetails,
        anyForeseeableChangesImpactingLoanRepayment: this.anyForeseeableChangesImpactingLoanRepayment,
        typeOfChangeExpected: this.typeOfChangeExpected,
        howApplicantIntendToDoLoanRepaymentAfterChange: this.howApplicantIntendToDoLoanRepaymentAfterChange,
        increaseInLoanAmountForFinancingCostOfInsurance: this.increaseInLoanAmountForFinancingCostOfInsurance,
        balloonPaymentAtTheEndOfTheLoan: this.balloonPaymentAtTheEndOfTheLoan,
        whatToDoWithBalloonPaymentAtTheEndOfTheLoanTerm: this.whatToDoWithBalloonPaymentAtTheEndOfTheLoanTerm,
        whyAreYouLookingAtRefinancing: this.whyAreYouLookingAtRefinancing,
        detailedReasonForRefinancing: this.detailedReasonForRefinancing,
        isApplicantPlanningToRetireBeforeLoanCompletion: this.isApplicantPlanningToRetireBeforeLoanCompletion,
        howTheApplicantProposeToRepayTheLoanResponse: this.howTheApplicantProposeToRepayTheLoanResponse
      };
      if (this.whyDoesThisLoanTermSuitYourRequirements === 'Other') {
        applicantNCCP.whyDoesThisLoanTermSuitYourRequirementsDetails = this.whyDoesThisLoanTermSuitYourRequirementsDetails
      }
      this.$emit('nccp-object-created', applicantNCCP);
    },
    closeNccpPopup() {
      this.isVisible = false;
    },
  },

};
</script>
<style scoped lang="scss">
@import "@/assets/scss/theme.scss";

.proceed_error {
  border: 0;
  position: relative;
  padding: 20px 15px;
  line-height: 20px;
  margin-bottom: 20px;
  z-index: 99999 !important;
  background-color: #e31854;
  color: #FFFFFF;
  border-radius: 3px;
  box-shadow: 0 12px 20px -10px rgb(153 153 153 / 28%), 0 4px 20px 0px rgb(0 0 0 / 12%), 0 7px 8px -5px rgb(153 153 153 / 20%);
}

.dialogWrapper {
  overflow: scroll;
  padding-top: 15px;
  margin: 1% 1%;
}
</style>
  